import { ResourceRow } from '@/components/MapPage/CorporateViewTabs/ResourceTab/ResourceTabCard';
import { Modal } from 'react-bootstrap';

type ExternalResourceDetailModal = {
  row: ResourceRow;
  onClose: () => void;
};

const ExternalResourceDetailsModal = ({
  row,
  onClose,
}: ExternalResourceDetailModal) => {
  return (
    <Modal show={true} onHide={onClose} centered size="xl">
      <Modal.Header closeButton closeVariant="white">
        <Modal.Title>Raw External Resource Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <pre>{JSON.stringify(row.externalResourceInfo, null, 2)}</pre>
      </Modal.Body>
    </Modal>
  );
};

export default ExternalResourceDetailsModal;
